module.exports = __webpack_public_path__ + "img/GG.c7774605.svg";